import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from './constants';

const lazy = {
    LegacySettingsRedirect: lazyLoad(async () => {
        const { LegacySettingsRedirect } = await import('./LegacySettingsRedirect');

        return { default: LegacySettingsRedirect };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'navigation.company-settings',
        page: lazy.LegacySettingsRedirect,
        path: route.patterns.settings,
    },
];
